import { Font, StyleSheet } from '@react-pdf/renderer';

Font.register({
  family: 'Lato',
  fonts: [
    { src: '/Lato-Regular.ttf', fontWeight: 400 },
    { src: '/Lato-Bold.ttf', fontWeight: 700 },
  ],
});

export const styles = StyleSheet.create({
  page: {
    display: 'flex',
    flexDirection: 'row',
    width: '100%',
    height: '100%',
    paddingVertical: 20,
  },
  columnContainer: {
    flexDirection: 'row',
    width: '100%',
    height: '100%',
    gap: 0,
    paddingHorizontal: 53,
    overflow: 'hidden',
  },
  leftColumn: {
    flex: 1,
    padding: 10,
  },
  middleColumn: {
    flex: 1,
    padding: 10,
  },
  rightColumn: {
    position: 'relative',
    flex: 1,
    padding: 10,
  },

  title: {
    color: 'black',
    fontFamily: 'Lato',
    fontSize: 40,
    fontWeight: 900,
    lineHeight: 1.4,
    textTransform: 'uppercase',
    width: '85%',
  },
  columnContent: {
    backgroundColor: '#F5F5F5',
    border: '3px solid #EDEDED',
    borderRadius: '10px',
    paddingHorizontal: 20,
    paddingVertical: 20,
  },
  columnTitle: {
    fontFamily: 'Lato',
    fontWeight: 700,
    fontSize: 24,
    lineHeight: 1.25,
    color: '#27343d',
  },

  bulletRow: {
    flexDirection: 'row',
    alignItems: 'flex-start',
    marginBottom: 4,
  },

  bullet: {
    width: 12, // fixed bullet column
    fontFamily: 'Lato',
    fontSize: 15,
    color: '#27343d',
  },

  listItem: {
    flex: 1,
    color: '#27343d',
    fontFamily: 'Lato',
    fontSize: 15,
    lineHeight: 1.2,
  },

  buyNowWrapper: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: 10,
    width: '100%',

    marginTop: 20,
  },
  priceText: {
    fontFamily: 'Lato',
    fontWeight: 700,
    fontSize: 20,
  },
  ticketButton: {
    borderRadius: '5px',
    color: 'white',
    fontFamily: 'Lato',
    fontWeight: 700,
    fontSize: 16,
    textAlign: 'center',
    textDecoration: 'none',

    width: 120,
    paddingVertical: 8,
    paddingHorizontal: 10,
    marginTop: 10,
  },
  coLocatedWithText: {
    color: '#27343d',
    fontFamily: 'Lato',
    fontWeight: 400,
    fontSize: 14,
  },
  coLocatedImageWrapper: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: 10,
    width: '100%',
  },
  coLocatedImageLogo: {
    width: 120,
    height: 40,
    objectFit: 'contain',
  },
});
